<template>
  <v-row justify="center" style="z-index: 999">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar class="mb-4">
            <v-toolbar-title>
                <span v-if="isPersonal" class="text-h5">{{ $t('contacts.btn.personalContacts') }}</span>
                <span v-else class="text-h5">{{ $t('contacts.btn.sharedContacts') }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <span v-if="contact">{{ isPersonal ? $t('contacts.deleteForm.confirmationPersonal') : $t('contacts.deleteForm.confirmation') }} <span class="red--text">{{ contact.name }}</span>?</span><br/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            color="red"
            :disabled="!contact"
            @click="submit()"
          >
            {{ $t('contacts.btn.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-deleteForm',
  computed: {
    ...mapGetters({
      dialog: 'contacts/deleteForm/dialog',
      isPersonal: 'contacts/deleteForm/isPersonal',
      contact: 'contacts/deleteForm/contact'
    })
  },
  methods: {
    ...mapActions({
      delete: 'contacts/delete',
      close: 'contacts/deleteForm/close'
    }),

    submit () {
      this.delete(this.contact)
      this.close()
    }
  }
}
</script>

<style>

</style>
